import { render, staticRenderFns } from "./BigBtn.vue?vue&type=template&id=23cdbecd&"
import script from "./BigBtn.vue?vue&type=script&lang=js&"
export * from "./BigBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports